<template>
  <GenericDrawer
    colorKey="bgAppBar"
    :isSubDrawer="true"
    :isOpen="isOpen"
    :topLinks="topLinks"
    @toggle="$emit('toggle', $event)"
  >
    <template v-slot:prepend>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Administration</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </template>
  </GenericDrawer>
</template>

<script>
import { ADMIN_DRAWER_TOP } from "@/utils/links"

export default {
  name: "AdminDrawer",
  components: {
    GenericDrawer: () => import("@/components/layouts/core/GenericDrawer.vue")
  },
  props: {
    isOpen: { type: Boolean, default: true },
    isMobile: { type: Boolean, default: false },
  },
  data: () => ({
    topLinks: ADMIN_DRAWER_TOP
  })
}
</script>
